import { useEffect, useRef } from 'react';
import FootballPitch from '../../components/FootballPitch';

const CITIES = [
  { city: 'Dubai',            games: 24, color: 'var(--coral)' },
  { city: 'Abu Dhabi',        games: 18, color: 'var(--gold)'  },
  { city: 'Sharjah',          games: 12, color: '#5BC4A8'      },
  { city: 'Ajman',            games:  8, color: 'var(--muted)' },
  { city: 'Ras Al Khaimah',   games:  5, color: 'var(--muted)' },
];

const TAGS = ['🇦🇪 UAE-First','🤝 Community','🔮 Scout-Ready','📊 Stats'];

export default function UAESection() {
  const pitchRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      if (!pitchRef.current) return;
      const rect = pitchRef.current.getBoundingClientRect();
      const pct  = Math.max(0, Math.min(1, 1 - rect.top / window.innerHeight));
      pitchRef.current.style.transform = `translateY(${(pct - 0.5) * -40}px)`;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section style={{ padding: '7rem clamp(1rem,4vw,3rem)', background: 'var(--navy2)', position: 'relative', overflow: 'hidden' }}>
      {/* Parallax pitch bg */}
      <div ref={pitchRef} style={{ position: 'absolute', inset: 0, opacity: 0.07, willChange: 'transform', pointerEvents: 'none' }}>
        <FootballPitch style={{ width: '100%', height: '100%' }} />
      </div>

      <div style={{
        maxWidth: 1100, margin: '0 auto',
        display: 'grid', gridTemplateColumns: '1fr 1fr',
        gap: '5rem', alignItems: 'center', position: 'relative', zIndex: 2,
      }}>
        {/* Copy */}
        <div className="vis">
          <span className="section-tag">BUILT FOR THE UAE</span>
          <h2 className="section-title" style={{ fontSize: 'clamp(36px,4.5vw,56px)', marginBottom: '2rem' }}>
            The Community<br /><span>That Plays Together</span>
          </h2>
          <p style={{ color: 'var(--muted)', fontSize: 16, lineHeight: 1.85, marginBottom: '1.5rem' }}>
            88.5% of UAE residents are expats. Most never get scouted—not because they're not good enough, but because scouts don't watch neighbourhood games.
          </p>
          <p style={{ color: 'var(--muted)', fontSize: 16, lineHeight: 1.85, marginBottom: '2rem' }}>
            Hadafi starts with organizing. But it's building something bigger:{' '}
            <strong style={{ color: 'var(--white)' }}>pathways from street to stadium.</strong>
          </p>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            {TAGS.map((tag) => (
              <span key={tag} style={{
                background: 'rgba(232,96,74,0.12)',
                border: '1px solid rgba(232,96,74,0.25)',
                borderRadius: 4, padding: '6px 14px',
                fontFamily: 'var(--font-m)', fontSize: 11,
                color: 'var(--coral)', letterSpacing: 1,
              }}>{tag}</span>
            ))}
          </div>
        </div>

        {/* Live games chart */}
        <div className="vis" style={{ position: 'relative' }}>
          <div style={{
            background: 'var(--navy3)', borderRadius: 12, padding: '2rem',
            border: '1px solid rgba(232,96,74,0.1)',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: '1.5rem' }}>
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: 'var(--coral)', animation: 'pulse2 2s infinite' }} />
              <span style={{ fontFamily: 'var(--font-m)', fontSize: 11, color: 'var(--coral)', letterSpacing: 2 }}>
                LIVE GAMES IN UAE
              </span>
            </div>
            {CITIES.map((c) => (
              <div key={c.city} style={{ marginBottom: '1.2rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                  <span style={{ fontFamily: 'var(--font-b)', fontSize: 14, fontWeight: 500 }}>{c.city}</span>
                  <span style={{ fontFamily: 'var(--font-m)', fontSize: 12, color: c.color }}>{c.games} games</span>
                </div>
                <div style={{ height: 4, background: 'rgba(255,255,255,0.06)', borderRadius: 2 }}>
                  <div className="vis" style={{
                    height: '100%', borderRadius: 2, background: c.color,
                    width: `${(c.games / 24) * 100}%`,
                    transition: 'width 1.5s cubic-bezier(.2,.8,.3,1)',
                  }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
